/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsPreview,
    MelcoModelsPreviewFromJSON,
    MelcoModelsPreviewFromJSONTyped,
    MelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsCustomProductListItem
 */
export interface MelcoFusionModelsCustomProductListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    blank_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    blank_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<MelcoModelsPreview>}
     * @memberof MelcoFusionModelsCustomProductListItem
     */
    default_previews?: Array<MelcoModelsPreview> | null;
}

export function MelcoFusionModelsCustomProductListItemFromJSON(json: any): MelcoFusionModelsCustomProductListItem {
    return MelcoFusionModelsCustomProductListItemFromJSONTyped(json, false);
}

export function MelcoFusionModelsCustomProductListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCustomProductListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'blank_id': !exists(json, 'blank_id') ? undefined : json['blank_id'],
        'blank_name': !exists(json, 'blank_name') ? undefined : json['blank_name'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'default_previews': !exists(json, 'default_previews') ? undefined : (json['default_previews'] === null ? null : (json['default_previews'] as Array<any>).map(MelcoModelsPreviewFromJSON)),
    };
}

export function MelcoFusionModelsCustomProductListItemToJSON(value?: MelcoFusionModelsCustomProductListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'token': value.token,
        'name': value.name,
        'blank_id': value.blank_id,
        'blank_name': value.blank_name,
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'default_previews': value.default_previews === undefined ? undefined : (value.default_previews === null ? null : (value.default_previews as Array<any>).map(MelcoModelsPreviewToJSON)),
    };
}


